import { Component, Input, OnChanges, OnInit, OnDestroy, DoCheck, SimpleChanges, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import { Dnd5eSheet } from '../../models/dnd5e-sheet';
import { Role } from '../../models/role';
import { DocumentLoadService } from  '../../services/document-load.service'

@Component({
  selector: 'app-dnd5e-sheet',
  templateUrl: './dnd5e-sheet.component.html',
  styleUrls: ['./dnd5e-sheet.component.scss']
})

export class Dnd5eSheetComponent implements OnInit, OnDestroy, OnChanges {
  
  private sheetDoc: AngularFirestoreDocument<Dnd5eSheet>;
  sheetInput: Observable<Dnd5eSheet>;
  error: string;
  role: Role;
  docid: string;
  differ: any;
  alive: boolean;
  @Input() sheeet: Dnd5eSheet = { title: "", owner_id: "" };

  constructor(
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private dls: DocumentLoadService,
    private differs: KeyValueDiffers
  ) {}

  ngOnInit() {
    this.alive = true;
    this.differ = this.differs.find({}).create();
    this.docid = this.route.snapshot.paramMap.get('id');
    this.sheetDoc = this.afs.collection<Dnd5eSheet>('dnd5e-sheets').doc(this.docid);
    this.dls.loadDocument(this.sheetDoc, this.docid).then((role: Role) => {
      this.role = role;
      this.sheetInput = this.sheetDoc.valueChanges();
      this.watchSheet();
    }).catch(error => {
      this.error = error;
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  watchSheet() {
    // Observable.timer(0, 1000).flatMap(() => {
    //   console.log('yep');
    //   this.sheetInput.subscribe(s => {
    //     var changes = this.differ.diff(s);
    //     console.log(changes);
    //     if (changes) {
    //       console.log(changes);
    //     }
    //   });
    // })
    // this.sheetInput.subscribe(s => {
    //   this.sheeet = s;
    //   console.log(s);
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes');
    console.log(changes);
  }

  updateSheet() {
    this.afs.collection<Dnd5eSheet>('dnd5e-sheets').doc(this.docid).update(this.sheetInput)
  }
}



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/game/dnd5e-sheet/dnd5e-sheet.component.ts